<template>
  <div v-if="adImageUrl" :class="['ad-preview', extraClasses, { show: adImageUrl}]">
    <img :src="adImageUrl" :alt="imgAlt">
    <div v-if="adAsLink" class="image-as-link-preview">
      <svg viewBox="0 0 512.092 512.092" class="sb-icon">
        <use xlink:href="#link-icon"></use>
      </svg>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      extraClasses: {
        default: '',
        required: false,
        type: String
      },
      imgAlt: {
        default: 'preview of selected ad',
        required: false,
        type: String
      },
      messageModuleName: {
        default: 'message',
        required: true,
        type: String
      },
    },

    name: 'AdImage',

    computed: {
      ...mapState({
        adAsLink (state, getters) { return getters[`${this.messageModuleName}/adAsLink`] },
        adImageUrl (state, getters) { return getters[`${this.messageModuleName}/adImageUrl`] }
      })
    }
  }
</script>